export const rowOf = (c: number) => Math.floor(c / 9);
export const colOf = (c: number) => c % 9;
export const boxOf = (c: number) => 3 * Math.floor(rowOf(c) / 3) + Math.floor(colOf(c) / 3);

export const sees = (a: number, b: number) =>
  a !== b && (rowOf(a) === rowOf(b) || colOf(a) === colOf(b) || boxOf(a) === boxOf(b));

/** The 20 cells sharing a row, column or box with each cell. */
export const PEERS: readonly number[][] = Array.from({ length: 81 }, (_, a) =>
  Array.from({ length: 81 }, (_, b) => b).filter((b) => sees(a, b)),
);

/** "Row 4, column 7" for screen readers. */
export const cellLabel = (c: number) => `Row ${rowOf(c) + 1}, column ${colOf(c) + 1}`;
